import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { SNETButton, SNETDialog } from "shared/dist/components";
import classes from "./ConfirmationPopup.module.css";

const ConfirmationPopup = ({ open, handleClose, handleContinue }) => {
    const handleCancel = () => {
        handleClose();
    };

    return (
        <SNETDialog
            isDialogOpen={open}
            onDialogClose={handleClose}
            title="Confirm Details"
            contentClass={classes.orgCreationConfirmationModal}
        >
            <Typography className={classes.popupDescription}>
                Please verify the information entered. Once submitted the details cannot be
                modified.
            </Typography>
            <Box className={classes.buttonsContainer}>
                <SNETButton
                    children="cancel"
                    color="primary"
                    variant="outlined"
                    onClick={handleCancel}
                />
                <SNETButton
                    children="continue"
                    color="primary"
                    variant="contained"
                    onClick={handleContinue}
                />
            </Box>
        </SNETDialog>
    );
};

export default ConfirmationPopup;
